import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { cn } from '@core/utils';
import type { HomeGiftProductDto } from '@generated/unauth';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthApi, UnauthQueryKey, UnauthQueryOptions } from '@/api';
import { GiftListItem } from '@/app/donation/_components/GiftListItem';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { DEFAULT_GIFT_PRODUCT_SORT } from '../../constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
import { SORT_OPTIONS } from './constants';
import type { SortValue } from './types';
interface GiftsContentProps {
  institutionId: number;
  initialData?: HomeGiftProductDto[];
}

/** 답례품 content */
export const GiftsContent = t0 => {
  const $ = _c(28);
  const {
    institutionId,
    initialData
  } = t0;
  const [selectedSort, setSelectedSort] = useState(DEFAULT_GIFT_PRODUCT_SORT);
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const pageSize = isDesktopViewport ? 8 : 6;
  let t1;
  if ($[0] !== institutionId) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/home/gift-product/by-institution"]({
      query: {
        institutionId,
        page: 1,
        size: 1
      }
    });
    $[0] = institutionId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      ...t1,
      select: _temp
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: totalCount
  } = useSuspenseQuery(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("mt-64 font-700 text-Gray-900 typo-body2", "mobile-tablet:mt-24");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SectionTitle className={cn("mb-32", "mobile-tablet:mb-12")}>답례품</SectionTitle>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = totalCount ?? 0;
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="font-500 text-Gray-black typo-body4"><span>전체 {t5}개</span></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== selectedSort) {
    t7 = <DropdownMenu type="text" value={selectedSort} options={SORT_OPTIONS} onChange={setSelectedSort} align="end" contentClassName="!min-w-160" />;
    $[8] = selectedSort;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="mb-12 flex items-center justify-between">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("grid grid-cols-4 gap-x-14 gap-y-32", "mobile-tablet:grid-cols-2");
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <InfiniteListMoreButton className={cn("mt-16", "mobile-tablet:mt-0")} />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  let t12;
  if ($[15] !== institutionId || $[16] !== pageSize || $[17] !== selectedSort) {
    t11 = [...UnauthQueryKey["get:/wello/v2/allows/home/gift-product/by-institution"](), selectedSort, institutionId, pageSize];
    t12 = t13 => {
      const {
        pageParam
      } = t13;
      return UnauthApi["get:/wello/v2/allows/home/gift-product/by-institution"]({
        query: {
          giftProductSortType: selectedSort,
          institutionId,
          size: pageSize,
          page: pageParam
        }
      }).then(_temp2);
    };
    $[15] = institutionId;
    $[16] = pageSize;
    $[17] = selectedSort;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  let t13;
  if ($[20] !== initialData || $[21] !== pageSize || $[22] !== t11 || $[23] !== t12) {
    t13 = <div className={t9}><InfiniteListWithMoreButton initialData={initialData} moreButtonComponent={t10} queryKey={t11} queryFn={t12} pageSize={pageSize} renderItem={_temp3} getItemKey={_temp4} /></div>;
    $[20] = initialData;
    $[21] = pageSize;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t8) {
    t14 = <div className={t3}>{t4}{t8}{t13}</div>;
    $[25] = t13;
    $[26] = t8;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
function _temp(data) {
  return data.context?.totalCount ?? 0;
}
function _temp2(data_0) {
  return data_0.data?.context?.contents ?? [];
}
function _temp3(item, index) {
  return <GiftListItem mainImageUrl={item.mainImageUrl} title={item.productName} isSoldOut={item.productSaleStatus === GIFT_SALE_STATUS.SOLD_OUT} donationAmount={item.requiredDonationAmount} reviewRating={item.reviewRating} reviewCount={item.reviewCount} productNumber={item.productSlugId ?? item.productNumber} onGiftLinkClick={() => {
    trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
      currency: "KRW",
      value: item.requiredDonationAmount,
      local_name: item.institutionName,
      items: [{
        item_type: "\uB2F5\uB840\uD488",
        item_list_name: "\uC9C0\uC790\uCCB4 \uC0C1\uC138 \uB2F5\uB840\uD488 \uD0ED",
        item_list_id: item.productNumber,
        price: item.requiredDonationAmount,
        item_name: item.productName,
        quantity: 1,
        item_id: item.productNumber
      }]
    });
  }} isAdult={item.adultYN} isNew={item.newDisplayYN} priority={index < 4} />;
}
function _temp4(item_0) {
  return item_0.productNumber;
}